import { createI18nText } from '@hilma/netina2all';
import FreeSalePercentText from './FreeSalePercentText';

const freeSaleText = createI18nText({
	he: {
		closed: 'המכירה סגורה לשנה זאת.',
		notEnoughSold: <FreeSalePercentText />,
		linkTo: 'קישור למכירה:',
		open: 'המכירה פתוחה כעת!',
		copy: 'העתק קישור',
		copied: 'הועתק ללוח',
		saleIsClosed: 'המכירה סגורה.',
		saleWillBeOpen: 'המכירה תיפתח כאשר תתבצע חלוקה של ',
		ofKits: '% מהמוצרים.',
	},

	en: {
		closed: 'The sale is closed for this year.',
		notEnoughSold: <FreeSalePercentText />,
		linkTo: 'Link to sale:',
		open: 'The sale is open now!',
		copy: 'Copy link',
		copied: 'Copied to clipboard',
		saleIsClosed: 'The sale is closed.',
		saleWillBeOpen: 'The sale will open when ',
		ofKits: '% of the products are distributed.',
	}
});

export default freeSaleText;